import { render, staticRenderFns } from "./EventViewHeader.vue?vue&type=template&id=20995fa3"
import script from "./EventViewHeader.vue?vue&type=script&lang=js"
export * from "./EventViewHeader.vue?vue&type=script&lang=js"
import style0 from "./EventViewHeader.vue?vue&type=style&index=0&id=20995fa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports